import styled from "styled-components";

export const TableContainer = styled.div`
    overflow-x: auto;
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    @media (max-width: ${props=>props.theme.breakpoints.mobile}) {
    border-radius: 0;
    margin: 0 -10px;
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
`;

export const Th = styled.th`
    background: #f5f5f5;
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #ddd;
    white-space: nowrap;
`;

export const Td = styled.td`
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    color: #666;

    &.actions {
    display: flex;
    gap: 8px;
    }
`;